import { render, staticRenderFns } from "./ApproversTable.vue?vue&type=template&id=0f560cee&scoped=true"
import script from "./ApproversTable.vue?vue&type=script&lang=js"
export * from "./ApproversTable.vue?vue&type=script&lang=js"
import style0 from "./ApproversTable.vue?vue&type=style&index=0&id=0f560cee&prod&lang=scss&scoped=true"
import style1 from "./ApproversTable.vue?vue&type=style&index=1&id=0f560cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f560cee",
  null
  
)

export default component.exports